<template>
  <div class="baiduQueue">
    <el-breadcrumb separator="/" style="padding-left: 50px;margin-top:30px">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报告详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="output" v-if="item.id">
      <!-- <div class="title">输出</div> -->
      <div class="o1">
        <!-- <div>{{ item.title }}</div> -->
        <el-image :src="item.image" :preview-src-list="[item.image]"></el-image>
        <div style="border: 1px solid #dee3ec;">
          <div
            style="border-bottom: 1px solid #dee3ec;display:flex;padding:20px"
          >
            <div class="detail-title">图片类型:</div>
            <div class="detail-desc">{{ changeImageType(item.picType) }}</div>
          </div>
          <div style="border-bottom: 1px solid #dee3ec;padding:20px">
            <div class="detail-title" style="margin-bottom:8px">报告标题:</div>
            <!-- <div class="detail-desc">{{ item.title }}</div> -->
            <el-input type="textarea" v-model="item.title"></el-input>
          </div>
          <div style="display:flex;padding:20px">
            <div class="detail-title">模型名称:</div>
            <div class="detail-desc">
              {{ item.model == 1 ? "CXR-Reportor" : "CXR-TMRGM" }}
            </div>
          </div>
        </div>
      </div>
      <div style="background:#F7F8FA;padding:12px;border-radius: 12px;">
        <div style="border: 1px solid #dee3ec;border-radius: 12px;">
          <div class="box2" style="display:flex">
            <div style="color: #3F455D;">报告日期</div>
            <div style="margin-left:30px;color: #3F455D;font-weight: 500;">
              {{ changeDate(item.gmtCreate) }}
            </div>
          </div>
          <div class="o2 box">
            <div class="o21 b1">标签</div>
            <div class="o22">
              <el-tag
                :key="tag"
                v-for="tag in item.tagsStr"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput"
                >+添加标签</el-button
              >
            </div>
          </div>
          <div class="o3 box">
            <div class="o31 b1">检查所见</div>
            <div class="textareaBox" :class="textUpdate1 ? '' : 'boxBorder'">
              <el-input
                type="textarea"
                v-model="item.overview"
                :autosize="{ minRows: 2, maxRows: 10 }"
                :readonly="textUpdate1"
              ></el-input>
              <el-button
                type="text"
                :icon="textUpdate1 ? 'el-icon-edit' : 'el-icon-check'"
                @click="updateText(1, '')"
              ></el-button>
              <!-- {{ textUpdate1 ? "编辑" : "完成" }} -->
            </div>
            <div class="textareaBox" :class="textUpdate1En ? '' : 'boxBorder'">
              <el-input
                type="textarea"
                v-model="item.overviewEn"
                :autosize="{ minRows: 2, maxRows: 10 }"
                :readonly="textUpdate1En"
              ></el-input>
              <el-button
                type="text"
                :icon="textUpdate1En ? 'el-icon-edit' : 'el-icon-check'"
                @click="updateText(1, 'En')"
              ></el-button>
              <!-- {{ textUpdate1En ? "编辑" : "完成" }} -->
            </div>
          </div>
          <div class="o3 box">
            <div class="o31 b1">检查意见</div>
            <div class="textareaBox" :class="textUpdate2 ? '' : 'boxBorder'">
              <el-input
                type="textarea"
                v-model="item.suggestion"
                :autosize="{ minRows: 2, maxRows: 10 }"
                :readonly="textUpdate2"
              ></el-input>
              <el-button
                type="text"
                :icon="textUpdate2 ? 'el-icon-edit' : 'el-icon-check'"
                @click="updateText(2, '')"
              ></el-button>
              <!-- {{ textUpdate2 ? "编辑" : "完成" }} -->
            </div>
            <div class="textareaBox" :class="textUpdate2En ? '' : 'boxBorder'">
              <el-input
                type="textarea"
                v-model="item.suggestionEn"
                :autosize="{ minRows: 2, maxRows: 10 }"
                :readonly="textUpdate2En"
              ></el-input>
              <el-button
                type="text"
                :icon="textUpdate2En ? 'el-icon-edit' : 'el-icon-check'"
                @click="updateText(2, 'En')"
              ></el-button>
              <!-- {{ textUpdate2En ? "编辑" : "完成" }} -->
            </div>
          </div>
          <div v-if="item.findingDtoList[0].textEn">
            <div v-for="(item, index) in item.findingDtoList" :key="index">
              <div class="o3 box" v-if="item.imgs.length == 0">
                <div class="o31 b1">发现{{ index + 1 }}</div>
                <div
                  class="textareaBox"
                  :class="item.textUpdate ? '' : 'boxBorder'"
                >
                  <el-input
                    type="textarea"
                    v-model="item.text"
                    :autosize="{ minRows: 2, maxRows: 10 }"
                    :readonly="item.textUpdate"
                  ></el-input>
                  <el-button
                    type="text"
                    :icon="item.textUpdate ? 'el-icon-edit' : 'el-icon-check'"
                    @click="updateText2(index, '')"
                  ></el-button>
                  <!-- {{ item.textUpdate ? "编辑" : "完成" }} -->
                </div>
                <div
                  class="textareaBox"
                  :class="item.textUpdateEn ? '' : 'boxBorder'"
                >
                  <el-input
                    type="textarea"
                    v-model="item.textEn"
                    :autosize="{ minRows: 2, maxRows: 10 }"
                    :readonly="item.textUpdateEn"
                  ></el-input>
                  <el-button
                    type="text"
                    :icon="item.textUpdateEn ? 'el-icon-edit' : 'el-icon-check'"
                    @click="updateText2(index, 'En')"
                  ></el-button>
                  <!-- {{ item.textUpdateEn ? "编辑" : "完成" }} -->
                </div>
              </div>
              <div class="o4 box" v-if="item.imgs.length == 1">
                <div class="o41 b1">发现{{ index + 1 }}</div>
                <div class="o42">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o421"
                    :class="item.textUpdate ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.text"
                      :autosize="{ minRows: 10, maxRows: 15 }"
                      :readonly="item.textUpdate"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="item.textUpdate ? 'el-icon-edit' : 'el-icon-check'"
                      @click="updateText2(index, '')"
                    ></el-button>
                    <!-- {{ item.textUpdate ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
              <div class="o4 box" v-if="item.imgs.length == 1">
                <div class="o41 b1">发现{{ index + 1 }}</div>
                <div class="o42">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o421"
                    :class="item.textUpdateEn ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.textEn"
                      :autosize="{ minRows: 10, maxRows: 15 }"
                      :readonly="item.textUpdateEn"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="
                        item.textUpdateEn ? 'el-icon-edit' : 'el-icon-check'
                      "
                      @click="updateText2(index, 'En')"
                    ></el-button>
                    <!-- {{ item.textUpdateEn ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
              <div class="o5 box" v-if="item.imgs.length == 2">
                <div class="b1">发现{{ index + 1 }}</div>
                <div class="o52">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <el-image
                    :src="item.imgs[1]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o521"
                    :class="item.textUpdate ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.text"
                      :autosize="{ minRows: 11, maxRows: 20 }"
                      :readonly="item.textUpdate"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="item.textUpdate ? 'el-icon-edit' : 'el-icon-check'"
                      @click="updateText2(index, '')"
                    ></el-button>
                    <!-- {{ item.textUpdate ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
              <div class="o5 box" v-if="item.imgs.length == 2">
                <div class="b1">发现{{ index + 1 }}</div>
                <div class="o52">
                  <el-image
                    :src="item.imgs[0]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <el-image
                    :src="item.imgs[1]"
                    :preview-src-list="item.imgs"
                  ></el-image>
                  <div
                    class="textareaBox o521"
                    :class="item.textUpdatecn ? '' : 'boxBorder'"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.textEn"
                      :autosize="{ minRows: 11, maxRows: 20 }"
                      :readonly="item.textUpdateEn"
                    ></el-input>
                    <el-button
                      type="text"
                      :icon="
                        item.textUpdateEn ? 'el-icon-edit' : 'el-icon-check'
                      "
                      @click="updateText2(index, 'En')"
                    ></el-button>
                    <!-- {{ item.textUpdateEn ? "编辑" : "完成" }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="o6" style="flex:1">
            <el-button
              v-if="token != 'xxx'"
              type="primary"
              @click="saveData(1)"
              style="background: linear-gradient(180deg, #16796F 0%, #045A51 100%);border: 1px solid #004B43;"
              >保存为报告</el-button
            >
            <el-button
              v-else
              type="primary"
              @click="saveData(1)"
              style="opacity:0 ;background: linear-gradient(180deg, #16796F 0%, #045A51 100%);border: 1px solid #004B43;"
              >保存为报告</el-button
            >
            <el-button
              v-if="token != 'xxx'"
              @click="saveData(2)"
              class="btnClass11"
              style="background: linear-gradient(180deg, #FFFFFF 0%, #F9F9FB 100%);border: 1px solid #D7DCE4;"
              >导出报告</el-button
            >
            <el-button
              v-else
              type="primary"
              @click="saveData(1)"
              style="opacity:0 ;background: linear-gradient(180deg, #16796F 0%, #045A51 100%);border: 1px solid #004B43;"
              >保存为报告</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item: {},
      textUpdate1: true,
      textUpdate2: true,
      textUpdate1En: true,
      textUpdate2En: true,
      inputVisible: false,
      inputValue: "",
      token: localStorage.getItem("token")
    };
  },
  computed: {},
  components: {},
  methods: {
    //改变时间类型
    changeDate(e) {
      let de = new Date(e);
      let year = de.getFullYear();
      let month = de.getMonth() + 1 > 10 ? de.getMonth() : "0" + de.getMonth();
      let day = de.getDate() > 10 ? de.getDate() : "0" + de.getDate();

      let hour = de.getHours() > 10 ? de.getHours() : "0" + de.getHours();
      let min = de.getMinutes() > 10 ? de.getMinutes() : "0" + de.getMinutes();
      let ss = de.getSeconds() > 10 ? de.getSeconds() : "0" + de.getSeconds();

      return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + ss;
    },
    //检测图片类型
    changeImageType(e) {
      switch (e) {
        case 1:
          return "CT";
        case 2:
          return "X-ray";
        case 3:
          return "MRI";
        case 4:
          return "US";
        case 5:
          return "PET";
        case 6:
          return "Other";
        default:
          break;
      }
    },
    // 保存报告
    saveData(e) {
      if (!this.item.overview) {
        this.$message({
          message: "请填写总体发现",
          type: "warning"
        });
        return;
      } else if (!this.item.suggestion) {
        this.$message({
          message: "请填写影像意见",
          type: "warning"
        });
        return;
      }
      for (let i in this.item.findingDtoList) {
        if (!this.item.findingDtoList[i].text) {
          this.$message({
            message: "请填写发现内容不因为空",
            type: "warning"
          });
          return;
        }
      }
      let params = {
        dbId: this.item.id,
        findings: this.item.findingDtoList,
        id: this.item.requestId,
        image: this.item.image,
        overview: this.item.overview,
        suggestion: this.item.suggestion,
        tagsStr: this.item.tagsStr.toString(),
        title: this.item.title
      };
      if (e == 1) {
        this.$axios.post("/medicine/save", params).then(res => {
          if (res.data.code == 0) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
          }
        });
      } else {
        this.$axios.post("/medicine/export", params).then(res => {
          if (res.data.code == 0) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            window.open(res.data.data);
          }
        });
      }
    },
    updateText(e, index) {
      if (e == 1) {
        this[`textUpdate1${index}`] = !this[`textUpdate1${index}`];
        if (this[`textUpdate1${index}`] && index == "") {
          let params = {
            text: this.item[`overview${index}`],
            type: index == "En" ? 2 : 1
          };
          this.$axios
            .get("/medicine/translateGeneral", { params })
            .then(res => {
              this.item[`overview${index == "En" ? "" : "En"}`] = res.data.data;
            });
        }
      } else {
        this[`textUpdate2${index}`] = !this[`textUpdate2${index}`];
        if (this[`textUpdate2${index}`] && index == "") {
          let params = {
            text: this.item[`suggestion${index}`],
            type: index == "En" ? 2 : 1
          };
          this.$axios
            .get("/medicine/translateGeneral", { params })
            .then(res => {
              this.item[`suggestion${index == "En" ? "" : "En"}`] =
                res.data.data;
            });
        }
      }
    },
    updateText2(e, index) {
      let item = this.item.findingDtoList[e];
      item[`textUpdate${index}`] = !item[`textUpdate${index}`];
      if (item[`textUpdate${index}`] && index == "") {
        let params = {
          text: item[`text${index}`],
          type: index == "En" ? 2 : 1
        };
        this.$axios.get("/medicine/translateGeneral", { params }).then(res => {
          item[`text${index == "En" ? "" : "En"}`] = res.data.data;
        });
      }
      this.$set(this.item.findingDtoList, e, item);
    },
    // 标签
    handleClose(tag) {
      this.item.tagsStr.splice(this.item.tagsStr.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.item.tagsStr.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    getData() {
      this.$axios.post("/medicine/info/" + this.$route.query.id).then(res => {
        if (res.data.code == 0) {
          this.item = res.data.data;
          for (let i in this.item.findingDtoList) {
            this.item.findingDtoList[i].textUpdate = true;
            this.item.findingDtoList[i].textUpdateEn = true;
            this.$axios
              .get("/medicine/translateGeneral", {
                params: { text: this.item.findingDtoList[i].text, type: 1 }
              })
              .then(res => {
                this.item.findingDtoList[i].textEn = res.data.data;
              });
          }
          if (this.item.tagsStr) {
            this.item.tagsStr = this.item.tagsStr.split(",");
          } else {
            this.item.tagsStr = [];
          }
          this.$axios
            .get("/medicine/translateGeneral", {
              params: { text: this.item.overview, type: 1 }
            })
            .then(res => {
              this.item.overviewEn = res.data.data;
            });
          this.$axios
            .get("/medicine/translateGeneral", {
              params: { text: this.item.suggestion, type: 1 }
            })
            .then(res => {
              this.item.suggestionEn = res.data.data;
            });
        }
      });
    }
  },

  mounted() {
    if (!this.$route.query.id) {
      return;
    }
    this.getData();
  }
};
</script>
<style scoped>
@import "../../assets/allCss.scss";
/deep/ .el-textarea .el-textarea__inner:focus {
  border: 1px solid #045a51;
}
/deep/ .el-textarea .el-textarea__inner {
  padding: 5px 24px 5px 15px !important;
  box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.08);
}
.detail-desc {
  font-weight: 900;
  font-size: 14px;
  color: #3f455d;
  margin-left: 20px;
}
.detail-title {
  font-weight: 400;
  font-size: 14px;
  color: #3f455d;
}
.output .o1 .el-image {
  width: 634px;
  height: 362px;
  /* display: block; */
  border-radius: 12px;
  margin: 0 auto 20px;
}
/* .output .o1 div {
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 18px;
  color: #3f455d;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 20px;
} */
.output .o1 {
  background: #f7f8fa;
  border: 1px solid #dee3ec;
  padding: 10px;
  border-radius: 12px;
  height: auto;
  margin-right: 30px;
}
.output .o2 .o22 .el-tag + .el-tag {
  margin-left: 10px;
}
.output .o2 .o22 .button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.output .o2 .o22 .input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.output .o2 {
  height: 100px;
  /* padding: 20px 40px 0; */
}

.o3 {
}
.output .o4 .o42 .o421 {
  width: 65%;
}
.output .o4 .o42 .el-image {
  width: 374px;
  height: 246px;
  display: block;
  border-radius: 12px;
}
.output .o4 .o42 {
  display: flex;
  justify-content: space-between;
}
.output .o5 .o52 .el-image {
  width: 374px;
  height: 246px;
  display: block;
  border-radius: 12px;
}
.output .o5 .o52 .o521 {
  width: 35%;
}
.output .o5 .o52 {
  display: flex;
  justify-content: space-between;
}
.output .o6 .el-button {
  width: 300px;
}
.output .o6 {
  padding: 50px 20px;
  display: flex;
  justify-content: center;
}
.output {
  width: calc(100% - 80px);
  margin: 32px auto;
  background: #ffffff;
  /* border: 1px solid #dee3ec; */
  border-radius: 12px;
  display: flex;
  justify-content: center;
}
.textareaBox /deep/ .el-textarea {
  /* width: calc(100% - 56px); */
}
.textareaBox /deep/ .el-textarea textarea {
  border: 1px solid transparent;
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 14px;
  color: #3f3f3f;
}
.textareaBox {
  position: relative;
  width: 100%;
  height: auto;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  resize: vertical;
  border-radius: 4px;
  margin-bottom: 10px;
}
.textareaBox .el-button {
  position: absolute;
  right: 6px;
}
.box2 {
  height: auto;
  /* width: calc(100% - 80px); */
  padding: 12px;
  border-bottom: 1px solid #dee3ec;
}
.box {
  height: auto;
  /* width: calc(100% - 80px); */
  padding: 20px 12px;
  border-bottom: 1px solid #dee3ec;
}
.box .b1 {
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 14px;
  color: #3f455d;
  margin-bottom: 12px;
}
.title {
  width: calc(100% - 20px);
  height: 60px;
  border-radius: 12px 12px 0 0;
  background: #f8f8fa;
  border-bottom: 1px solid #dee3ec;
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 17px;
  color: #3f3f3f;
  line-height: 60px;
  padding-left: 20px;
}
.boxBorder {
  border: 1px solid #29bccf;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/index.vue